import './Input.css';
import PropTypes from 'prop-types';

const Input = (props) => {
  const inputType = props.type || 'text';
  return (
    <input
      className={'fmc-input ' + props.className}
      placeholder={props.placeholder}
      maxLength={props.maxLength}
      value={props.value}
      onChange={props.onChange}
      name={props.name}
      pattern={props.pattern}
      type={inputType}
      readOnly={props.isReadOnly}
    />
  );
};

Input.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
  value: PropTypes.any,
  onChange: PropTypes.func,
  name: PropTypes.string,
  pattern: PropTypes.string,
  isReadOnly: PropTypes.any,
  type: PropTypes.string
};

export default Input;
